import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import API from "../../services/axiosInstance";
import InvoiceForm from "./InvoiceForm";


const UpdateInvoice = () => {
    // const [publisherName, setPublisherName] = useState("");
    const url = useParams();
    const accId = url?.id;
    const accGuid = url?.guid;
    const invId = url?.invId;

    const { state } = useLocation();
    const id = state?.invoiceId;

    const [defaultValues, setDefaultValues] = useState(null);


    const invoiceData = async () => {

        try {
            const invoiceDataRes = await API.get(`/publisher/invoice/${invId}/${accId}`);
            const data = invoiceDataRes?.data?.data;
            // setPublisherName(invoiceDataRes?.data?.name);

            let approve_status = "Pending";
            let payment_status = "Pending";

            switch (data.finalStatus) {
                case 0:
                case 1:
                    approve_status = "Pending";
                    payment_status = "Pending";
                    break;

                case 2:
                    approve_status = "Pending";
                    payment_status = "Pending";
                    break;

                case 3:
                    approve_status = "Disapprove";
                    payment_status = "Pending";
                    break;

                case 4:
                    approve_status = "Pending";
                    payment_status = "Pending";
                    break;

                case 5:
                    approve_status = "Approve";
                    payment_status = "Pending";
                    break;

                case 6:
                    approve_status = "Approve";
                    payment_status = "Paid";
                    break;

            }
            setDefaultValues({
                id: id,
                accountId: accId,
                accountGuid: accGuid,
                invoiceSeries: data.invoiceSeries,
                month: data.invoiceMonth,
                year: data.invoiceYear,
                currency: data.currency,
                payment: data.paymentAmount,
                payment_date: data.paymentDate,
                description: data.description,
                invoiceFile: data.invoiceFile || "",
                finalStatus: data.finalStatus,
                filePath: data.filePath || "",
                approve_status,
                payment_status,
                //  status:5,
                //  reminderCount:0,
            });
        } catch (error) {
            console.error("API Error:", error);
        }
    }

    useEffect(() => {
        invoiceData();
    }, []);

    if (!defaultValues) return

    return (
        <InvoiceForm mode="edit"
            defaultValues={defaultValues}
            // publisherName={publisherName}
        />
    )
}

export default UpdateInvoice;